import { Button, Spinner } from "@heroui/react";

import { useLanguage } from "@onesolution/hooks";

type ErrorContentProps = {
	refetch: () => void;
	isFetching: boolean;
};

export default function ErrorContent({
	refetch,
	isFetching,
}: ErrorContentProps) {
	const { t } = useLanguage();

	return (
		<div className="flex flex-col items-center justify-center size-full gap-4">
			<span className="text-center text-gray-500">{t("message.error")}</span>
			<Button onPress={refetch} disabled={isFetching} color="primary">
				{isFetching ? <Spinner size="sm" /> : t("basic.retry")}
			</Button>
		</div>
	);
}
